import { observer } from 'mobx-react';
import GroupParticipantsStore from '../GroupParticipantsStore/Store';
import FiltersWithOptions from './FiltersWithOptions';
import Search from './Search';

interface Props {
  groupParticipantsStore: GroupParticipantsStore;
}

function Filters({ groupParticipantsStore }: Props) {
  return (
    <div className="flex items-end flex-row mb-5 sm:flex-col sm:items-start">
      <Search groupParticipantsStore={groupParticipantsStore} />
      <FiltersWithOptions groupParticipantsStore={groupParticipantsStore} />
    </div>
  );
}

export default observer(Filters);
